import { AxiosPublic } from '../../../config/axios';
import { useState, useEffect, useRef } from 'react';

export default function Search({ label, url, errors, touch, name, setData, defaultValue }) {
    const hasError = (touch[name] && errors[name]) ? true : false

    const [query, setQuery] = useState(defaultValue || '');
    const [results, setResults] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const FirstTime = useRef(true)

    useEffect(() => {
        if (!FirstTime.current) {
            const fetchResults = async () => {
                if (query.length > 2) {
                    setIsLoading(true);
                    await AxiosPublic.get(`${url}?title=${query}`)
                        .then(res => setResults(res.data.data.data))
                    setIsLoading(false);
                } else {
                    setResults([]);
                }
            };
            fetchResults();
        }
        FirstTime.current = false;
    }, [query]);

    const handleClick = (event) => {
        setQuery(event.title);
        setResults([])
        setData(prev => {
            return {
                ...prev,
                [name]: event.id
            }
        }
        )
    }

    const handleTouch = ({ currentTarget }) => {
        if (currentTarget.id !== 'dropdown_list')
            setResults([])
    }

    useEffect(() => {
        window.addEventListener('click', handleTouch)
        return () => window.removeEventListener('click', handleTouch)
    }, [])


    return (
        <>
            <div className="relative">
                <input
                    type="text" id={`outlined_${url}`}
                    className={`block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-1 ${hasError ? 'border-red-500' : 'border-gray-300'} appearance-none dark:text-white focus:outline-none focus:ring-0 peer`}
                    placeholder="جستجو"
                    value={query} name={name}
                    onChange={(e) => setQuery(e.target.value)}
                />
                <label htmlFor={`outlined_${url}`} className={`absolute ${hasError ? 'text-red-500' : ''} rounded-lg text-sm duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto`}>{label}</label>
            </div>
            {isLoading && <div className="absolute top-12 left-0 w-full text-right bg-white border border-gray-300 rounded-lg shadow-lg mt-1 p-2 z-10">درحال بارگذاری</div>}
            {!!results.length && (
                <ul className="flex flex-col absolute top-12 left-0 w-full bg-white border border-gray-300 rounded-lg shadow-lg mt-1 p-2 z-20 max-h-96 overflow-y-auto" dir='ltr' id='dropdown_list'>
                    {results.map(result => (
                        <li key={result.id} className="p-2 hover:bg-gray-100 cursor-pointer w-full text-right" onClick={() => handleClick(result)}>
                            {result.title}
                        </li>
                    ))}
                </ul >
            )}
            {hasError && <p className="absolute right-2 bottom-0 text-xs text-red-600">{errors[name]}</p>}
        </>
    );
}
